export default __webpack_public_path__ + "static/media/remove.af611b9b.svg";